import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'redux'
import CSSModules from 'helpers/CSSModulesUtil'

import FilterMenu from './FilterMenu'
import ApprovalList from './ApprovalList'

import theme from './NavDrawerContent.scss'

import {
  FETCH_APPROVALS,
} from 'containers/Approval/ApprovalPage/constants'

import {
  productCategorySelector,
  approvalsSelector,
  currentApprovalSelector,
} from 'containers/Approval/ApprovalPage/selectors'

import {
  rejectStart,
  acceptStart,
} from 'containers/Approval/ApprovalDialog/actions'

import {
  changeProductCategoryFilter,
  fetchApprovals
} from 'containers/Approval/ApprovalPage/actions'

import ProgressBarHoc from 'containers/Async/AsyncProgressBar'

const ProgressBar = ProgressBarHoc([FETCH_APPROVALS])

const mapStateToProps = state => {
  return {
    approvals: approvalsSelector(state),
    currentApproval: currentApprovalSelector(state),
    filter: productCategorySelector(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    rejectApproval: (workflowId, approverWorkflowStateId) => {
      dispatch(rejectStart(workflowId, approverWorkflowStateId))
    },
    acceptApproval: (workflowId, approverWorkflowStateId) => {
      dispatch(acceptStart(workflowId, approverWorkflowStateId))
    },
    changeFilter: (filter) => {
      dispatch(changeProductCategoryFilter(filter))
    },
    getApprovals: () => dispatch(fetchApprovals())
  }
}

class NavDrawer extends Component {
  static propTypes = {
    approvals: PropTypes.array.isRequired,
    rejectApproval: PropTypes.func.isRequired,
    acceptApproval: PropTypes.func.isRequired,
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.string.isRequired,
  }

  static defaultProps = {
    approvals: [],
    filter: 'all'
  }

  render() {
    let {
      changeFilter,
      getApprovals,
      filter,
      ...rest
    } = this.props

    return (
      <div>
        <FilterMenu
          changeFilter={ changeFilter }
          getApprovals={ getApprovals }
          filter={ filter }
        />
        <ApprovalList
          {...rest}
        />
        <ProgressBar/>
      </div>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyles = CSSModules(theme)
const enhance = compose(
  withConnect,
  withStyles,
)

export default enhance(NavDrawer)
